import { createSelector } from 'reselect';
import {
  prop,
  path,
  pipe,
  pick,
  map,
  reduce,
  either,
  replace,
  isNil,
  mergeLeft,
  pathOr,
} from 'ramda';

const localState = prop('organization');

export const getPractitionersLoading = createSelector(
  localState,
  prop('practionersLoading'),
);

export const getAllPractitioners = createSelector(
  localState,
  prop('practitioners'),
);

export const getOrganizationFetchingStatus = createSelector(
  localState,
  either(prop('fetching'), prop('initial')),
);

export const getSiteId = createSelector(
  prop('router'),
  pipe(
    path(['location', 'pathname']),
    replace('/sites/', ''),
  ),
);

export const getOrganizationId = createSelector(
  localState,
  pipe(
    path(['data', 'managingOrganization', '0', 'reference']),
    replace('Organization/', ''),
  ),
);

export const getSiteEmail = createSelector(
  localState,
  orgData => pipe(path(['data', 'note', '0', 'text']))(orgData),
);

export const isSuperCareteam = createSelector(
  localState,
  pipe(
    path(['data', 'managingOrganization', '0', 'reference']),
    isNil,
  ),
);

export const handleOrganizationResponse = pipe(
  prop('response'),
  pick(['id', 'status', 'name', 'participant', 'note', 'managingOrganization']),
);

export const getParticipantIdObject = createSelector(
  localState,
  pipe(
    pathOr([], ['data', 'participant']),
    map(
      pipe(
        path(['member', 'reference']),
        replace('Practitioner/', ''),
      ),
    ),
    reduce((acc, participant) => ({ ...acc, [participant]: true }), {}),
  ),
);

export const getUpdatedSuperCareteam = participant =>
  createSelector(
    localState,
    pipe(
      prop('data'),
      mergeLeft({ participant, resourceType: 'CareTeam' }),
    ),
  );

export const getOrganizationName = createSelector(
  localState,
  path(['data', 'name']),
);
